// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"eR","speechCardBox":"eR","speech-img-box":"eS","speechImgBox":"eS","card-content":"eT","cardContent":"eT","card-src":"eU","cardSrc":"eU"};